import { render, staticRenderFns } from "./StepInformation.vue?vue&type=template&id=0c713156&scoped=true&"
import script from "./StepInformation.vue?vue&type=script&lang=js&"
export * from "./StepInformation.vue?vue&type=script&lang=js&"
import style0 from "./StepInformation.vue?vue&type=style&index=0&id=0c713156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c713156",
  null
  
)

export default component.exports